import { render, staticRenderFns } from "./info-alert.vue?vue&type=template&id=6b24682e"
import script from "./info-alert.vue?vue&type=script&lang=js"
export * from "./info-alert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports